import { useState, useEffect } from "react";

// ─── Supabase ─────────────────────────────────────────────────────────────────
const SUPA_URL = "https://sttxnvafmnavuurszytx.supabase.co";
const SUPA_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InN0dHhudmFmbW5hdnV1cnN6eXR4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzY5NDgxODUsImV4cCI6MjA5MjUyNDE4NX0.CEd4VcNSlXLm7v1LjHzXgHx2q71KLsVx3cEq094ZB9s";

const api = async (path, method="GET", body) => {
  const r = await fetch(`${SUPA_URL}/rest/v1/${path}`, {
    method,
    headers: { "Content-Type":"application/json", "apikey":SUPA_KEY, "Authorization":`Bearer ${SUPA_KEY}`, "Prefer":"return=representation" },
    body: body ? JSON.stringify(body) : undefined,
  });
  if (!r.ok) { const e = await r.json(); throw new Error(e.message||"Erro"); }
  return r.status===204 ? null : r.json();
};

// eslint-disable-next-line no-unused-vars
const authApi = async (path, body) => {
  const r = await fetch(`${SUPA_URL}/auth/v1/${path}`, {
    method: "POST",
    headers: { "Content-Type":"application/json", "apikey":SUPA_KEY },
    body: JSON.stringify(body),
  });
  const data = await r.json();
  if (!r.ok) throw new Error(data.error_description||data.msg||"Erro de autenticação");
  return data;
};

// ─── Constantes ───────────────────────────────────────────────────────────────
const PALETTE = ["#00e676","#4488ff","#ff6b35","#f7c948","#b06aff","#00bcd4","#ff4d6d","#69f0ae","#ffab40","#e040fb"];
const cor = (i) => PALETTE[i % PALETTE.length];

const PLANOS = {
  analytics: {
    nome: "VotôMetro Analytics",
    preco: "R$29,90",
    cor: "#4488ff",
    icone: "📊",
    desc: "Ideal para empresas, sindicatos e grêmios",
    beneficios: [
      "✅ Eleições internas ilimitadas",
      "✅ Cálculo de margem de erro",
      "✅ Nível de confiança 95%",
      "✅ Projeção de vencedor",
      "✅ Exportação CSV",
      "✅ Coleta pelo pesquisador",
      "❌ Perfil do eleitor",
      "❌ Análise por região",
      "❌ Links para entrevistadores",
    ],
    limiteLinks: 0,
    perfilEleitor: false,
    regioes: false,
    tipos: ["interna"],
  },
  pro: {
    nome: "VotôMetro Pro",
    preco: "R$99,90",
    cor: "#00e676",
    icone: "🏆",
    desc: "Completo para pesquisas eleitorais profissionais",
    beneficios: [
      "✅ Eleições municipais e nacionais",
      "✅ Eleições internas",
      "✅ Cálculo de margem de erro",
      "✅ Nível de confiança 95%",
      "✅ Projeção de vencedor",
      "✅ Perfil do eleitor (sexo/idade)",
      "✅ Análise por região",
      "✅ Análise de rejeição",
      "✅ Problemas da cidade",
      "✅ 2º Turno hipotético",
      "✅ Até 20 links por pesquisa",
      "✅ Exportação CSV",
    ],
    limiteLinks: 20,
    perfilEleitor: true,
    regioes: true,
    tipos: ["municipal","nacional","interna"],
  },
};

const TIPOS = {
  municipal: { label:"🏙️ Eleições Municipais", desc:"Prefeito e Vereador", cargosFixos:["Prefeito","Prefeito 2º Turno","Vereador"], livre:false, problemas:true, plano:"pro" },
  nacional:  { label:"🇧🇷 Eleições Nacionais",  desc:"Presidente, Governador, Senador, Deputados", cargosFixos:["Presidente","Presidente 2º Turno","Governador","Governador 2º Turno","Senador","Deputado Federal","Deputado Estadual"], livre:false, problemas:true, plano:"pro" },
  interna:   { label:"🏢 Eleições Internas",    desc:"Empresas, Sindicatos, Grêmios", cargosFixos:[], livre:true, problemas:false, plano:"analytics" },
};

const CARGOS_2T_FIXO = ["Presidente 2º Turno","Governador 2º Turno","Prefeito 2º Turno"];
const PROBLEMAS_LIST = ["Saúde","Educação","Segurança","Transporte","Saneamento","Emprego","Habitação","Meio Ambiente"];
const TRIAL_DAYS = 7;

// ─── Helpers ──────────────────────────────────────────────────────────────────
const getDaysLeft = (d) => Math.max(0, Math.ceil((new Date(d).getTime()+TRIAL_DAYS*86400000-Date.now())/86400000));
const gerarLinkId = () => Math.random().toString(36).slice(2,10)+Date.now().toString(36);

function calcStats(votos, total) {
  if (!total) return [];
  const z=1.96;
  return votos.map(v=>{
    const p=v.count/total, e=z*Math.sqrt((p*(1-p))/Math.max(total,1));
    return {...v, pct:+(p*100).toFixed(2), erro:+(e*100).toFixed(2), dp:+Math.sqrt(p*(1-p)*total).toFixed(2), min:+Math.max(0,(p-e)*100).toFixed(2), max:+Math.min(100,(p+e)*100).toFixed(2)};
  }).sort((a,b)=>b.pct-a.pct);
}

function winner(stats) {
  const c=stats.filter(s=>!["Branco/Nulo","Indeciso/Não sabe"].includes(s.nome));
  if (!c.length) return null;
  const [p1,p2]=c;
  return {...p1, empate:p2?p1.min<=p2.max:false};
}

// ─── UI Base ──────────────────────────────────────────────────────────────────
const CSS = `@import url('https://fonts.googleapis.com/css2?family=Sora:wght@400;600;700;800&display=swap');*{box-sizing:border-box;margin:0;padding:0}body{background:#07101f;font-family:'Sora',sans-serif}button:focus{outline:none}`;
const S = { h2:{fontSize:22,fontWeight:800,color:"#fff",marginBottom:6,letterSpacing:"-0.4px"}, sub:{color:"#445577",fontSize:14,marginBottom:22} };

function Btn({children,onClick,variant="primary",disabled,full,small,style:ex={}}) {
  const v = variant==="primary"?{background:"linear-gradient(135deg,#00c956,#00e676)",color:"#07101f",boxShadow:"0 4px 18px #00e67630"}
    :variant==="blue"?{background:"linear-gradient(135deg,#2255cc,#4488ff)",color:"#fff",boxShadow:"0 4px 18px #4488ff30"}
    :variant==="danger"?{background:"#ff4d6d22",color:"#ff4d6d",border:"1px solid #ff4d6d44"}
    :{background:"transparent",color:"#7799bb",border:"1.5px solid #1a2b47"};
  return <button onClick={onClick} disabled={disabled} style={{fontFamily:"'Sora',sans-serif",fontWeight:700,border:"none",borderRadius:10,cursor:disabled?"not-allowed":"pointer",transition:"all .15s",opacity:disabled?.5:1,width:full?"100%":undefined,padding:small?"8px 16px":"13px 22px",fontSize:small?13:14,...v,...ex}}>{children}</button>;
}

function Card({children,style:ex={}}) { return <div style={{background:"#0d1829",border:"1px solid #1a2b47",borderRadius:14,padding:20,...ex}}>{children}</div>; }
function Lbl({children}) { return <div style={{color:"#7799bb",fontSize:11,fontWeight:700,textTransform:"uppercase",letterSpacing:"0.6px",marginBottom:8}}>{children}</div>; }
function Inp({value,onChange,placeholder,type="text",onKeyDown,style:ex={}}) {
  return <input type={type} value={value} onChange={e=>onChange(e.target.value)} placeholder={placeholder} onKeyDown={onKeyDown} style={{background:"#07101f",border:"1.5px solid #1a2b47",borderRadius:9,color:"#d0e0ff",fontFamily:"'Sora',sans-serif",fontSize:14,padding:"11px 14px",width:"100%",outline:"none",...ex}}/>;
}
function Tag({label,onRemove}) {
  return <span style={{display:"inline-flex",alignItems:"center",gap:6,background:"#07101f",border:"1px solid #1a2b47",borderRadius:20,padding:"4px 12px",fontSize:13,color:"#c0d0f0",margin:"3px"}}>{label}<button onClick={onRemove} style={{background:"none",border:"none",color:"#ff4d6d",cursor:"pointer",fontSize:15,lineHeight:1,padding:0}}>×</button></span>;
}
function Bar({pct,color="#00e676"}) {
  return <div style={{background:"#07101f",borderRadius:6,height:8,overflow:"hidden"}}><div style={{width:`${Math.min(pct,100)}%`,height:"100%",background:color,borderRadius:6,transition:"width .8s ease"}}/></div>;
}
function Toast({msg}) {
  if (!msg) return null;
  return <div style={{position:"fixed",bottom:24,left:"50%",transform:"translateX(-50%)",background:"#00e676",color:"#07101f",fontFamily:"'Sora',sans-serif",fontWeight:700,fontSize:13,padding:"10px 28px",borderRadius:50,boxShadow:"0 4px 20px #00e67660",zIndex:999}}>{msg}</div>;
}
function Spinner() {
  return <div style={{display:"flex",justifyContent:"center",padding:40}}><div style={{width:36,height:36,borderRadius:"50%",border:"3px solid #1a2b47",borderTop:"3px solid #00e676",animation:"spin 0.8s linear infinite"}}/><style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style></div>;
}

// ─── Landing Page ─────────────────────────────────────────────────────────────
function Landing({onComecar, onLogin}) {
  return (
    <div style={{minHeight:"100vh",background:"#07101f",fontFamily:"'Sora',sans-serif",color:"#d0e0ff"}}>
      <style>{CSS}</style>

      {/* Nav */}
      <nav style={{background:"#0b1527",borderBottom:"1px solid #1a2b47",padding:"14px 24px",display:"flex",justifyContent:"space-between",alignItems:"center",position:"sticky",top:0,zIndex:100}}>
        <div style={{fontSize:20,fontWeight:800}}>🗳️ <span style={{background:"linear-gradient(90deg,#00e676,#4488ff)",WebkitBackgroundClip:"text",WebkitTextFillColor:"transparent"}}>VotôMetro</span></div>
        <div style={{display:"flex",gap:10}}>
          <Btn variant="secondary" small onClick={onLogin}>Entrar</Btn>
          <Btn small onClick={onComecar}>Começar grátis</Btn>
        </div>
      </nav>

      {/* Hero */}
      <div style={{textAlign:"center",padding:"70px 24px 50px",position:"relative",overflow:"hidden"}}>
        <div style={{position:"absolute",width:700,height:700,borderRadius:"50%",background:"radial-gradient(circle,#00e67612 0%,transparent 70%)",top:"50%",left:"50%",transform:"translate(-50%,-50%)",pointerEvents:"none"}}/>
        <div style={{fontSize:14,color:"#00e676",fontWeight:700,letterSpacing:2,marginBottom:16}}>PESQUISA ELEITORAL PROFISSIONAL</div>
        <h1 style={{fontSize:"clamp(32px,6vw,56px)",fontWeight:800,color:"#fff",letterSpacing:"-1.5px",marginBottom:16,lineHeight:1.1}}>Resultados precisos,<br/><span style={{background:"linear-gradient(90deg,#00e676,#4488ff)",WebkitBackgroundClip:"text",WebkitTextFillColor:"transparent"}}>estatísticas confiáveis</span></h1>
        <p style={{color:"#445577",fontSize:18,maxWidth:560,margin:"0 auto 36px",lineHeight:1.6}}>Colete intenções de voto com cálculo automático de margem de erro, nível de confiança e projeção de vencedor.</p>
        <Btn onClick={onComecar} style={{fontSize:16,padding:"16px 36px",marginBottom:12}}>Testar grátis por 7 dias →</Btn>
        <div style={{color:"#334466",fontSize:13,marginTop:8}}>Sem cartão de crédito · Cancele quando quiser</div>
      </div>

      {/* Stats */}
      <div style={{display:"flex",justifyContent:"center",gap:"clamp(20px,4vw,60px)",flexWrap:"wrap",padding:"0 24px 60px"}}>
        {[["95%","Nível de confiança"],["±2%","Margem de erro"],["∞","Entrevistas"],["20","Links por pesquisa"]].map(([n,d])=>(
          <div key={d} style={{textAlign:"center"}}>
            <div style={{fontSize:36,fontWeight:800,color:"#00e676"}}>{n}</div>
            <div style={{color:"#445577",fontSize:13,marginTop:4}}>{d}</div>
          </div>
        ))}
      </div>

      {/* Planos */}
      <div style={{maxWidth:820,margin:"0 auto",padding:"0 24px 80px"}}>
        <div id="planos" style={{position:"relative",top:-10}}/>
        <h2 style={{textAlign:"center",fontSize:28,fontWeight:800,color:"#fff",marginBottom:8}}>Escolha seu plano</h2>
        <p style={{textAlign:"center",color:"#445577",marginBottom:36}}>7 dias grátis em qualquer plano</p>
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(300px,1fr))",gap:20}}>
          {Object.entries(PLANOS).map(([key,p])=>(
            <div key={key} onClick={onComecar} style={{background:"#0d1829",border:`2px solid ${key==="pro"?"#00e676":"#1a2b47"}`,borderRadius:18,padding:28,position:"relative",cursor:"pointer",transition:"border-color .2s"}}
              onMouseEnter={e=>e.currentTarget.style.borderColor=p.cor}
              onMouseLeave={e=>e.currentTarget.style.borderColor=key==="pro"?"#00e676":"#1a2b47"}>
              {key==="pro" && <div style={{position:"absolute",top:-12,left:"50%",transform:"translateX(-50%)",background:"linear-gradient(135deg,#00c956,#00e676)",color:"#07101f",fontSize:11,fontWeight:800,padding:"4px 16px",borderRadius:20,whiteSpace:"nowrap"}}>MAIS POPULAR</div>}
              <div style={{fontSize:28,marginBottom:8}}>{p.icone}</div>
              <div style={{fontSize:18,fontWeight:800,color:"#fff",marginBottom:4}}>{p.nome}</div>
              <div style={{color:"#445577",fontSize:13,marginBottom:16}}>{p.desc}</div>
              <div style={{marginBottom:20}}>
                <span style={{fontSize:36,fontWeight:800,color:p.cor}}>{p.preco}</span>
                <span style={{color:"#334466",fontSize:13}}>/mês</span>
              </div>
              <div style={{marginBottom:24}}>
                {p.beneficios.map(b=>(
                  <div key={b} style={{color:b.startsWith("✅")?"#a0b8d8":"#334466",fontSize:13,marginBottom:6}}>{b}</div>
                ))}
              </div>
              <Btn full variant={key==="pro"?"primary":"blue"} onClick={e=>{e.stopPropagation();onComecar();}}>Começar com {p.nome}</Btn>
            </div>
          ))}
        </div>
      </div>

      {/* Features */}
      <div style={{background:"#0b1527",borderTop:"1px solid #1a2b47",padding:"60px 24px"}}>
        <div style={{maxWidth:820,margin:"0 auto"}}>
          <h2 style={{textAlign:"center",fontSize:26,fontWeight:800,color:"#fff",marginBottom:40}}>Tudo que você precisa para pesquisar</h2>
          <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(220px,1fr))",gap:20}}>
            {[
              ["📊","Estatísticas profissionais","Margem de erro, desvio padrão e intervalo de confiança 95% calculados automaticamente"],
              ["🏆","Projeção de vencedor","Identifica o candidato líder com detecção automática de empate técnico"],
              ["👤","Perfil do eleitor","Analise por sexo, faixa etária e região — exclusivo Pro"],
              ["🔗","Links para entrevistadores","Envie até 20 links e colete dados com sua equipe — exclusivo Pro"],
              ["📍","Análise regional","Veja onde cada candidato é forte ou fraco — exclusivo Pro"],
              ["⬇️","Exportação CSV","Exporte todos os dados para Excel e faça suas próprias análises"],
            ].map(([ic,title,desc])=>(
              <Card key={title} style={{padding:20}}>
                <div style={{fontSize:28,marginBottom:10}}>{ic}</div>
                <div style={{color:"#fff",fontWeight:700,fontSize:15,marginBottom:6}}>{title}</div>
                <div style={{color:"#445577",fontSize:13,lineHeight:1.5}}>{desc}</div>
              </Card>
            ))}
          </div>
        </div>
      </div>

      <div style={{textAlign:"center",padding:"40px 24px",color:"#334466",fontSize:13}}>
        © 2026 VotôMetro · Todos os direitos reservados · <a href="/politica-de-privacidade" style={{color:"#445577",textDecoration:"underline"}}>Política de Privacidade</a>
      </div>
    </div>
  );
}

// ─── Cadastro: Escolha do tipo → plano ───────────────────────────────────────
function FluxoCadastro({onSuccess, onBack}) {
  const [etapa, setEtapa] = useState("tipo"); // tipo | plano | form
  const [tipoEscolhido, setTipoEscolhido] = useState(null);
  const [planoEscolhido, setPlanoEscolhido] = useState(null);

  const tiposGrupos = [
    { grupo:"Eleições Políticas", tipos:[["municipal",TIPOS.municipal],["nacional",TIPOS.nacional]], planoReq:"pro" },
    { grupo:"Eleições Corporativas", tipos:[["interna",TIPOS.interna]], planoReq:"analytics" },
  ];

  if (etapa==="tipo") return (
    <div style={{minHeight:"100vh",background:"#07101f",display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
      <style>{CSS}</style>
      <div style={{maxWidth:520,width:"100%"}}>
        <button onClick={onBack} style={{background:"none",border:"none",color:"#445577",fontFamily:"'Sora',sans-serif",fontSize:13,cursor:"pointer",marginBottom:20}}>← Voltar</button>
        <h2 style={S.h2}>Que tipo de pesquisa você quer fazer?</h2>
        <p style={S.sub}>Escolha para ver os planos disponíveis.</p>
        <div style={{display:"flex",flexDirection:"column",gap:12}}>
          {tiposGrupos.map(({grupo,tipos,planoReq})=>(
            <div key={grupo}>
              <div style={{color:"#334466",fontSize:12,fontWeight:700,textTransform:"uppercase",letterSpacing:1,marginBottom:8}}>{grupo}</div>
              {tipos.map(([key,val])=>(
                <button key={key} onClick={()=>{setTipoEscolhido({key,val,planoReq});setEtapa("plano");}}
                  style={{width:"100%",background:"#0d1829",border:"2px solid #1a2b47",borderRadius:14,padding:"18px 22px",cursor:"pointer",textAlign:"left",marginBottom:8,transition:"border-color .2s"}}
                  onMouseEnter={e=>e.currentTarget.style.borderColor="#00e676"}
                  onMouseLeave={e=>e.currentTarget.style.borderColor="#1a2b47"}>
                  <div style={{fontSize:17,fontWeight:800,color:"#fff",marginBottom:4}}>{val.label}</div>
                  <div style={{color:"#445577",fontSize:13}}>{val.desc}</div>
                </button>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );

  if (etapa==="plano") {
    const planosDisponiveis = tipoEscolhido.planoReq==="analytics"
      ? Object.entries(PLANOS)
      : [["pro",PLANOS.pro]];

    return (
      <div style={{minHeight:"100vh",background:"#07101f",padding:"40px 20px"}}>
        <style>{CSS}</style>
        <div style={{maxWidth:820,margin:"0 auto"}}>
          <button onClick={()=>setEtapa("tipo")} style={{background:"none",border:"none",color:"#445577",fontFamily:"'Sora',sans-serif",fontSize:13,cursor:"pointer",marginBottom:24}}>← Voltar</button>
          <h2 style={{...S.h2,textAlign:"center",marginBottom:6}}>Escolha seu plano</h2>
          <p style={{...S.sub,textAlign:"center",marginBottom:32}}>7 dias grátis · Sem cartão de crédito</p>
          <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(300px,1fr))",gap:20}}>
            {planosDisponiveis.map(([key,p])=>(
              <div key={key} style={{background:"#0d1829",border:`2px solid ${planoEscolhido===key?p.cor:"#1a2b47"}`,borderRadius:18,padding:28,position:"relative",cursor:"pointer",transition:"border-color .2s"}}
                onClick={()=>setPlanoEscolhido(key)}>
                {key==="pro" && <div style={{position:"absolute",top:-12,left:"50%",transform:"translateX(-50%)",background:"linear-gradient(135deg,#00c956,#00e676)",color:"#07101f",fontSize:11,fontWeight:800,padding:"4px 16px",borderRadius:20,whiteSpace:"nowrap"}}>MAIS POPULAR</div>}
                <div style={{fontSize:26,marginBottom:8}}>{p.icone}</div>
                <div style={{fontSize:17,fontWeight:800,color:"#fff",marginBottom:4}}>{p.nome}</div>
                <div style={{fontSize:30,fontWeight:800,color:p.cor,marginBottom:4}}>{p.preco}<span style={{color:"#334466",fontSize:13}}>/mês</span></div>
                <div style={{color:"#445577",fontSize:13,marginBottom:16}}>{p.desc}</div>
                {p.beneficios.map(b=><div key={b} style={{color:b.startsWith("✅")?"#a0b8d8":"#334466",fontSize:12,marginBottom:5}}>{b}</div>)}
              </div>
            ))}
          </div>
          {planoEscolhido && (
            <div style={{textAlign:"center",marginTop:28}}>
              <Btn onClick={()=>setEtapa("form")} style={{fontSize:15,padding:"14px 36px"}}>
                Continuar com {PLANOS[planoEscolhido].nome} →
              </Btn>
            </div>
          )}
        </div>
      </div>
    );
  }

  return <FormCadastro plano={planoEscolhido} onSuccess={onSuccess} onBack={()=>setEtapa("plano")} />;
}

function FormCadastro({plano, onSuccess, onBack}) {
  const [nome, setNome] = useState("");
  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const [erro, setErro] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    setErro(""); setLoading(true);
    try {
      if (!nome.trim()||!email.includes("@")||senha.length<6) { setErro("Preencha todos os campos corretamente."); setLoading(false); return; }
      const existe = await api(`Usuários?email=eq.${encodeURIComponent(email)}&select=id`);
      if (existe?.length) { setErro("E-mail já cadastrado. Faça login."); setLoading(false); return; }
      const [user] = await api(`Usuários`, "POST", { Nome:nome, email, senha, plano, trial_start:new Date().toISOString() });
      // Enviar e-mail de boas-vindas
      fetch("/api/boas_vindas", {
        method:"POST",
        headers:{"Content-Type":"application/json"},
        body:JSON.stringify({nome, email, plano}),
      }).catch(()=>{}); // silencioso — não bloqueia o cadastro
      localStorage.setItem("vm_session", JSON.stringify(user));
      onSuccess(user);
    } catch(e) { setErro(e.message); }
    setLoading(false);
  };

  const p = PLANOS[plano];
  return (
    <div style={{minHeight:"100vh",background:"#07101f",display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
      <style>{CSS}</style>
      <div style={{maxWidth:400,width:"100%",background:"#0d1829",border:"1px solid #1a2b47",borderRadius:18,padding:32}}>
        <button onClick={onBack} style={{background:"none",border:"none",color:"#445577",fontFamily:"'Sora',sans-serif",fontSize:13,cursor:"pointer",marginBottom:20,padding:0}}>← Voltar</button>
        <div style={{background:`${p.cor}18`,border:`1px solid ${p.cor}44`,borderRadius:10,padding:"10px 16px",marginBottom:20,display:"flex",alignItems:"center",gap:10}}>
          <span style={{fontSize:20}}>{p.icone}</span>
          <div><div style={{color:p.cor,fontWeight:700,fontSize:14}}>{p.nome}</div><div style={{color:"#334466",fontSize:12}}>{p.preco}/mês · 7 dias grátis</div></div>
        </div>
        <h2 style={{fontSize:20,fontWeight:800,color:"#fff",marginBottom:20}}>Criar sua conta</h2>
        <div style={{marginBottom:14}}><Lbl>Nome completo</Lbl><Inp value={nome} onChange={setNome} placeholder="João Silva"/></div>
        <div style={{marginBottom:14}}><Lbl>E-mail</Lbl><Inp type="email" value={email} onChange={setEmail} placeholder="seu@email.com"/></div>
        <div style={{marginBottom:20}}><Lbl>Senha</Lbl><Inp type="password" value={senha} onChange={setSenha} placeholder="mínimo 6 caracteres"/></div>
        {erro && <div style={{color:"#ff4d6d",fontSize:13,marginBottom:14,textAlign:"center"}}>{erro}</div>}
        <Btn full onClick={handleSubmit} disabled={loading}>{loading?"Criando conta...":"Começar trial gratuito →"}</Btn>
        <p style={{color:"#2a3d5a",fontSize:11,textAlign:"center",marginTop:14,lineHeight:1.5}}>Ao criar conta você concorda com os termos de uso.</p>
      </div>
    </div>
  );
}

function FormLogin({onSuccess, onBack}) {
  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const [modo, setModo] = useState("login");
  const [erro, setErro] = useState("");
  const [msg, setMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async () => {
    setErro(""); setLoading(true);
    try {
      const users = await api(`Usuários?email=eq.${encodeURIComponent(email)}&senha=eq.${encodeURIComponent(senha)}&select=*`);
      if (!users?.length) { setErro("E-mail ou senha incorretos."); setLoading(false); return; }
      localStorage.setItem("vm_session", JSON.stringify(users[0]));
      onSuccess(users[0]);
    } catch(e) { setErro(e.message); }
    setLoading(false);
  };

  const handleRecuperar = async () => {
    setErro(""); setLoading(true);
    try {
      const users = await api(`Usuários?email=eq.${encodeURIComponent(email)}&select=id,email`);
      if (!users?.length) { setErro("E-mail não encontrado."); setLoading(false); return; }
      const token = Math.random().toString(36).slice(2,10).toUpperCase();
      const expira = new Date(Date.now()+3600000).toISOString();
      await api(`Usuários?id=eq.${users[0].id}`, "PATCH", { reset_token:token, reset_expira:expira });
      setMsg(`✅ Um código de recuperação foi gerado: ${token}\n\nUse esse código para redefinir sua senha. (Em produção, isso seria enviado por e-mail)`);
    } catch(e) { setErro(e.message); }
    setLoading(false);
  };

  return (
    <div style={{minHeight:"100vh",background:"#07101f",display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
      <style>{CSS}</style>
      <div style={{maxWidth:400,width:"100%",background:"#0d1829",border:"1px solid #1a2b47",borderRadius:18,padding:32}}>
        <button onClick={onBack} style={{background:"none",border:"none",color:"#445577",fontFamily:"'Sora',sans-serif",fontSize:13,cursor:"pointer",marginBottom:20,padding:0}}>← Voltar</button>
        <div style={{fontSize:36,textAlign:"center",marginBottom:10}}>🗳️</div>
        <h2 style={{fontSize:20,fontWeight:800,color:"#fff",textAlign:"center",marginBottom:6}}>{modo==="login"?"Entrar":"Recuperar senha"}</h2>
        <p style={{color:"#445577",fontSize:13,textAlign:"center",marginBottom:22}}>{modo==="login"?"Bem-vindo de volta!":"Digite seu e-mail para recuperar"}</p>

        {msg ? (
          <div style={{background:"#00e67618",border:"1px solid #00e676",borderRadius:10,padding:16,color:"#00e676",fontSize:13,lineHeight:1.6,marginBottom:16,whiteSpace:"pre-wrap"}}>{msg}</div>
        ) : <>
          <div style={{marginBottom:14}}><Lbl>E-mail</Lbl><Inp type="email" value={email} onChange={setEmail} placeholder="seu@email.com"/></div>
          {modo==="login" && <div style={{marginBottom:20}}><Lbl>Senha</Lbl><Inp type="password" value={senha} onChange={setSenha} placeholder="sua senha" onKeyDown={e=>e.key==="Enter"&&handleLogin()}/></div>}
          {erro && <div style={{color:"#ff4d6d",fontSize:13,marginBottom:14,textAlign:"center"}}>{erro}</div>}
          <Btn full onClick={modo==="login"?handleLogin:handleRecuperar} disabled={loading}>
            {loading?"Aguarde...":(modo==="login"?"Entrar →":"Enviar código de recuperação")}
          </Btn>
        </>}

        <div style={{textAlign:"center",marginTop:16}}>
          <button onClick={()=>{setModo(modo==="login"?"recuperar":"login");setErro("");setMsg("");}}
            style={{background:"none",border:"none",color:"#445577",fontFamily:"'Sora',sans-serif",fontSize:13,cursor:"pointer",textDecoration:"underline"}}>
            {modo==="login"?"Esqueci minha senha":"← Voltar para login"}
          </button>
        </div>
      </div>
    </div>
  );
}

// ─── Header ───────────────────────────────────────────────────────────────────
function Header({user, onLogout, extra}) {
  const p = PLANOS[user?.plano]||PLANOS.pro;
  const days = getDaysLeft(user?.trial_start||user?.created_at||new Date());
  return (
    <div style={{background:"#0b1527",borderBottom:"1px solid #1a2b47",position:"sticky",top:0,zIndex:100}}>
      <div style={{maxWidth:780,margin:"0 auto",padding:"12px 20px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
        <div>
          <span style={{fontSize:16,fontWeight:800}}>🗳️ <span style={{background:`linear-gradient(90deg,${p.cor},#4488ff)`,WebkitBackgroundClip:"text",WebkitTextFillColor:"transparent"}}>{p.nome}</span></span>
          <div style={{fontSize:11,color:"#2a3d5a",fontFamily:"monospace",marginTop:1}}>{user?.Nome} · {days}d de trial</div>
        </div>
        <div style={{display:"flex",gap:8}}>
          {extra}
          <Btn small variant="danger" onClick={()=>{
            if(window.confirm("Tem certeza que deseja cancelar sua assinatura?\n\nVocê será redirecionado para o Mercado Pago para concluir o cancelamento."))
              window.open("https://www.mercadopago.com.br/subscriptions","_blank");
          }} style={{fontSize:11,padding:"6px 10px"}}>Cancelar Assinatura</Btn>
          <Btn small variant="danger" onClick={onLogout}>Sair</Btn>
        </div>
      </div>
    </div>
  );
}

// ─── Painel do Pesquisador ────────────────────────────────────────────────────
function Painel({user, onLogout}) {
  const [tela, setTela] = useState("lista");
  const [pesquisas, setPesquisas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [ativa, setAtiva] = useState(null);
  const [entrevistas, setEntrevistas] = useState([]);
  const [toast, setToast] = useState("");
  const [linkCopiado, setLinkCopiado] = useState("");

  const plano = PLANOS[user.plano]||PLANOS.analytics;
  const isPro = user.plano==="pro";

  const showToast = m => { setToast(m); setTimeout(()=>setToast(""),2500); };

  const carregar = async () => {
    setLoading(true);
    try { setPesquisas(await api(`Pesquisas?usuario_id=eq.${user.id}&order=created_at.desc&select=*`)||[]); }
    catch(e) { console.error(e); }
    setLoading(false);
  };

  useEffect(()=>{ carregar(); },[]);// eslint-disable-line react-hooks/exhaustive-deps

  const salvarPesquisa = async (cfg) => {
    try {
      const linkId = gerarLinkId();
      await api(`Pesquisas`,"POST",{ usuario_id:String(user.id), nome:cfg.nome, tipo:cfg.tipo, config:{...cfg,linkId}, ativo:true });
      showToast("✅ Pesquisa criada!");
      await carregar();
      setTela("lista");
    } catch(e) { showToast("❌ "+e.message); }
  };

  const abrirColeta = async (p) => {
    setAtiva(p);
    try { setEntrevistas(await api(`entrevistas?pesquisa_id=eq.${p.id}&select=*`)||[]); }
    catch(e) {}
    setTela("coletar");
  };

  const abrirResultados = async (p) => {
    setAtiva(p);
    try { setEntrevistas(await api(`entrevistas?pesquisa_id=eq.${p.id}&select=*`)||[]); }
    catch(e) {}
    setTela("resultados");
  };

  const salvarEntrevista = async (entrevista) => {
    await api(`entrevistas`,"POST",{ pesquisa_id:ativa.id, data:entrevista.data, perfil:entrevista.perfil, votos:entrevista.votos, rejeicoes:entrevista.rejeicoes, problemas:entrevista.problemas, votos2t:entrevista.votos2T, respostas_perguntas:entrevista.respostasPerguntas });
    setEntrevistas(p=>[...p,entrevista]);
  };

  const excluirPesquisa = async (p) => {
    if (!window.confirm(`Excluir "${p.nome}"? Esta ação não pode ser desfeita.`)) return;
    try {
      await api(`entrevistas?pesquisa_id=eq.${p.id}`, "DELETE");
      await api(`Pesquisas?id=eq.${p.id}`, "DELETE");
      showToast("🗑️ Pesquisa excluída!");
      await carregar();
    } catch(e) { showToast("❌ "+e.message); }
  };

  const copiarLink = (p) => {
    const link = `${window.location.origin}?coleta=${p.config?.linkId||p.id}`;
    navigator.clipboard.writeText(link);
    setLinkCopiado(p.id); showToast("🔗 Link copiado!");
    setTimeout(()=>setLinkCopiado(""),3000);
  };

  const tiposDisponiveis = Object.entries(TIPOS).filter(([k,v])=>plano.tipos.includes(k));

  if (tela==="nova") return <TelaConfig tiposDisponiveis={tiposDisponiveis} isPro={isPro} onIniciar={salvarPesquisa} onCancelar={()=>setTela("lista")} />;

  if (tela==="coletar" && ativa) return (
    <div style={{minHeight:"100vh",background:"#07101f"}}>
      <style>{CSS}</style>
      <Header user={user} onLogout={onLogout} extra={<Btn small variant="secondary" onClick={()=>setTela("lista")}>← Pesquisas</Btn>} />
      <div style={{maxWidth:540,margin:"0 auto",padding:"26px 20px 80px"}}>
        <TelaColeta config={ativa.config} entrevistas={entrevistas} isPro={isPro}
          onSalvar={salvarEntrevista} onResultados={()=>setTela("resultados")} />
      </div>
      <Toast msg={toast}/>
    </div>
  );

  if (tela==="resultados" && ativa) return (
    <div style={{minHeight:"100vh",background:"#07101f"}}>
      <style>{CSS}</style>
      <Header user={user} onLogout={onLogout} extra={<Btn small variant="secondary" onClick={()=>setTela("lista")}>← Pesquisas</Btn>} />
      <div style={{maxWidth:780,margin:"0 auto",padding:"26px 20px 80px"}}>
        <TelaResultados
          config={ativa.config}
          isPro={isPro}
          entrevistas={entrevistas.map(e=>({...e,votos2T:e.votos2t}))}
          onVoltar={()=>setTela("lista")}
        />
      </div>
    </div>
  );

  return (
    <div style={{minHeight:"100vh",background:"#07101f"}}>
      <style>{CSS}</style>
      <Header user={user} onLogout={onLogout} extra={<Btn small onClick={()=>setTela("nova")}>+ Nova Pesquisa</Btn>} />
      <div style={{maxWidth:780,margin:"0 auto",padding:"26px 20px 80px"}}>
        <h2 style={S.h2}>Minhas Pesquisas</h2>
        <p style={S.sub}>Crie uma pesquisa, colete você mesmo ou envie links para entrevistadores.</p>
        {loading ? <Spinner/> : pesquisas.length===0 ? (
          <Card style={{textAlign:"center",padding:48}}>
            <div style={{fontSize:48,marginBottom:12}}>📋</div>
            <p style={{color:"#445577",marginBottom:20}}>Nenhuma pesquisa ainda.</p>
            <Btn onClick={()=>setTela("nova")}>+ Criar Pesquisa</Btn>
          </Card>
        ) : pesquisas.map(p=>(
          <Card key={p.id} style={{marginBottom:12,display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:12}}>
            <div>
              <div style={{color:"#fff",fontWeight:700,fontSize:16}}>{p.nome}</div>
              <div style={{color:"#445577",fontSize:12,marginTop:2}}>{TIPOS[p.tipo]?.label} · {new Date(p.created_at).toLocaleDateString("pt-BR")}</div>
            </div>
            <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
              <Btn small variant="secondary" onClick={()=>abrirColeta(p)}>📋 Coletar</Btn>
              {isPro && <Btn small variant={linkCopiado===p.id?"secondary":"blue"} onClick={()=>copiarLink(p)}>{linkCopiado===p.id?"✓ Copiado":"🔗 Link"}</Btn>}
              <Btn small onClick={()=>abrirResultados(p)}>📊 Resultados</Btn>
              <Btn small variant="danger" onClick={()=>excluirPesquisa(p)}>🗑️</Btn>
            </div>
          </Card>
        ))}

        {/* Banner upgrade discreto no rodapé — só para Analytics */}
        {!isPro && !loading && <BannerUpgradePro />}
      </div>
      <Toast msg={toast}/>
    </div>
  );
}

// ─── Coleta pública via link ──────────────────────────────────────────────────
function ColetaPublica({linkId}) {
  const [pesquisa, setPesquisa] = useState(null);
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState("");
  const [entrevistas, setEntrevistas] = useState([]);
  const [toast, setToast] = useState("");
  const showToast = m => { setToast(m); setTimeout(()=>setToast(""),2500); };

  useEffect(()=>{
    api(`Pesquisas?select=*`).then(data=>{
      const f=data?.find(p=>p.config?.linkId===linkId);
      if (!f) setErro("Link inválido ou pesquisa encerrada.");
      else setPesquisa(f);
      setLoading(false);
    }).catch(()=>{ setErro("Erro ao carregar."); setLoading(false); });
  },[linkId]);

  const salvar = async (e) => {
    await api(`entrevistas`,"POST",{ pesquisa_id:pesquisa.id, data:e.data, perfil:e.perfil, votos:e.votos, rejeicoes:e.rejeicoes, problemas:e.problemas, votos2t:e.votos2T });
    setEntrevistas(p=>[...p,e]);
    showToast("✅ Entrevista salva!");
  };

  if (loading) return <div style={{...{minHeight:"100vh",background:"#07101f"},display:"flex",alignItems:"center",justifyContent:"center"}}><style>{CSS}</style><Spinner/></div>;
  if (erro) return <div style={{minHeight:"100vh",background:"#07101f",display:"flex",alignItems:"center",justifyContent:"center"}}><style>{CSS}</style><Card style={{textAlign:"center",padding:40,maxWidth:380}}><div style={{fontSize:48,marginBottom:12}}>❌</div><p style={{color:"#ff4d6d",fontWeight:700}}>{erro}</p></Card></div>;

  return (
    <div style={{minHeight:"100vh",background:"#07101f"}}>
      <style>{CSS}</style>
      <div style={{background:"#0b1527",borderBottom:"1px solid #1a2b47",padding:"12px 20px",textAlign:"center"}}>
        <span style={{fontSize:16,fontWeight:800}}>🗳️ <span style={{background:"linear-gradient(90deg,#00e676,#4488ff)",WebkitBackgroundClip:"text",WebkitTextFillColor:"transparent"}}>VotôMetro</span></span>
        <div style={{fontSize:12,color:"#334466",marginTop:2}}>{pesquisa.nome}</div>
      </div>
      <div style={{maxWidth:540,margin:"0 auto",padding:"26px 20px 80px"}}>
        <TelaColeta config={pesquisa.config} entrevistas={entrevistas} isPro={true} onSalvar={salvar} onResultados={null}/>
      </div>
      <Toast msg={toast}/>
    </div>
  );
}

// ─── Config da Pesquisa ───────────────────────────────────────────────────────
function TelaConfig({tiposDisponiveis, isPro, onIniciar, onCancelar}) {
  const [tipo, setTipo] = useState(null);
  const [nome, setNome] = useState("");
  const [regioes, setRegioes] = useState([]);
  const [novaReg, setNovaReg] = useState("");
  const [cargosLivres, setCargosLivres] = useState([]);
  const [novoCargo, setNovoCargo] = useState("");
  const [candidatos, setCandidatos] = useState({});
  const [novoCand, setNovoCand] = useState({});
  const [perguntas, setPerguntas] = useState([]);
  const [novaPergunta, setNovaPergunta] = useState("");
  const [novasOpcoes, setNovasOpcoes] = useState({});

  const OPCOES_PADRAO = ["Ótimo","Bom","Regular","Ruim","Péssimo","Sim","Não","Talvez","Conheço","Não conheço","Votaria","Não votaria"];

  const addPergunta = () => {
    const v = novaPergunta.trim();
    if (!v) return;
    setPerguntas(p=>[...p, {texto:v, opcoes:[]}]);
    setNovaPergunta("");
  };
  const delPergunta = (i) => setPerguntas(p=>p.filter((_,j)=>j!==i));
  const addOpcaoPergunta = (pi, opcao) => {
    const op = (novasOpcoes[pi]||opcao||"").trim();
    if (!op) return;
    setPerguntas(p=>p.map((pg,j)=>j===pi?{...pg,opcoes:[...pg.opcoes,op]}:pg));
    setNovasOpcoes(o=>({...o,[pi]:""}));
  };
  const delOpcaoPergunta = (pi, oi) => setPerguntas(p=>p.map((pg,j)=>j===pi?{...pg,opcoes:pg.opcoes.filter((_,k)=>k!==oi)}:pg));

  const t = tipo ? TIPOS[tipo] : null;
  const cargos = t ? (t.livre ? cargosLivres : t.cargosFixos) : [];

  const addReg=()=>{if(!novaReg.trim())return;setRegioes(p=>[...p,novaReg.trim()]);setNovaReg("");};
  const addCargo=()=>{const v=novoCargo.trim();if(!v||cargosLivres.includes(v))return;setCargosLivres(p=>[...p,v]);setNovoCargo("");};
  const delCargo=(i)=>{const n=cargosLivres[i];setCargosLivres(p=>p.filter((_,j)=>j!==i));setCandidatos(p=>{const c={...p};delete c[n];return c;});};
  const addCand=(cargo)=>{const v=(novoCand[cargo]||"").trim();if(!v)return;if(CARGOS_2T_FIXO.includes(cargo)&&(candidatos[cargo]||[]).length>=2)return;setCandidatos(p=>({...p,[cargo]:[...(p[cargo]||[]),v]}));setNovoCand(p=>({...p,[cargo]:""}));};
  const delCand=(cargo,i)=>setCandidatos(p=>({...p,[cargo]:p[cargo].filter((_,j)=>j!==i)}));

  const ok = tipo && nome.trim() && (isPro ? regioes.length>0 : true) && cargos.length>0 && cargos.some(c=>(candidatos[c]||[]).length>0);

  return (
    <div style={{minHeight:"100vh",background:"#07101f"}}>
      <style>{CSS}</style>
      <div style={{background:"#0b1527",borderBottom:"1px solid #1a2b47",padding:"12px 20px",display:"flex",alignItems:"center",gap:12}}>
        <button onClick={onCancelar} style={{background:"none",border:"none",color:"#445577",fontFamily:"'Sora',sans-serif",cursor:"pointer",fontSize:13}}>← Voltar</button>
        <span style={{fontSize:16,fontWeight:800,color:"#fff"}}>Nova Pesquisa</span>
      </div>
      <div style={{maxWidth:600,margin:"0 auto",padding:"24px 20px 80px"}}>
        <Card style={{marginBottom:14}}>
          <Lbl>Tipo de pesquisa</Lbl>
          <div style={{display:"flex",flexDirection:"column",gap:10}}>
            {tiposDisponiveis.map(([key,val])=>(
              <button key={key} onClick={()=>setTipo(key)}
                style={{padding:"16px 18px",borderRadius:12,border:`2px solid ${tipo===key?"#00e676":"#1a2b47"}`,background:tipo===key?"#001a0f":"#07101f",cursor:"pointer",textAlign:"left",transition:"all .2s"}}>
                <div style={{fontSize:16,fontWeight:700,color:tipo===key?"#00e676":"#fff"}}>{val.label}</div>
                <div style={{color:"#334466",fontSize:13,marginTop:2}}>{val.desc}</div>
              </button>
            ))}
          </div>
        </Card>

        {tipo && <>
          <Card style={{marginBottom:14}}><Lbl>Nome da pesquisa</Lbl><Inp value={nome} onChange={setNome} placeholder="Ex: Semana 1 · Abril/2026"/></Card>

          {isPro && (
            <Card style={{marginBottom:14}}>
              <Lbl>Regiões / Bairros</Lbl>
              <div style={{display:"flex",gap:8,marginBottom:10}}>
                <Inp value={novaReg} onChange={setNovaReg} placeholder="Nome da região" style={{flex:1}} onKeyDown={e=>e.key==="Enter"&&addReg()}/>
                <Btn onClick={addReg} disabled={!novaReg.trim()} small>+ Add</Btn>
              </div>
              <div>{regioes.map((r,i)=><Tag key={i} label={r} onRemove={()=>setRegioes(p=>p.filter((_,j)=>j!==i))}/>)}</div>
              {!regioes.length&&<p style={{color:"#2a3d5a",fontSize:12,marginTop:6}}>Adicione ao menos uma região.</p>}
            </Card>
          )}

          {t.livre && (
            <Card style={{marginBottom:14}}>
              <Lbl>Cargos da eleição</Lbl>
              <div style={{display:"flex",gap:8,marginBottom:10}}>
                <Inp value={novoCargo} onChange={setNovoCargo} placeholder="Ex: Diretor, Síndico..." style={{flex:1}} onKeyDown={e=>e.key==="Enter"&&addCargo()}/>
                <Btn onClick={addCargo} disabled={!novoCargo.trim()} small>+ Add</Btn>
              </div>
              <div>{cargosLivres.map((c,i)=><Tag key={i} label={c} onRemove={()=>delCargo(i)}/>)}</div>
            </Card>
          )}

          {cargos.map(cargo=>{
            const numC=(candidatos[cargo]||[]).length, is2T=CARGOS_2T_FIXO.includes(cargo);
            return (
              <Card key={cargo} style={{marginBottom:14}}>
                <Lbl>{cargo}{is2T?<span style={{color:numC===2?"#00e676":"#f7c948",fontWeight:700,textTransform:"none",fontSize:11,marginLeft:8,background:numC===2?"#00e67622":"#f7c94822",border:`1px solid ${numC===2?"#00e676":"#f7c948"}`,borderRadius:20,padding:"2px 8px"}}>🔁 2º Turno · {numC}/2</span>:!t.livre&&<span style={{color:"#334466",fontWeight:400,textTransform:"none",fontSize:11,marginLeft:6}}>(opcional)</span>}</Lbl>
                <div style={{display:"flex",gap:8,marginBottom:10}}>
                  <Inp value={novoCand[cargo]||""} onChange={v=>setNovoCand(p=>({...p,[cargo]:v}))} placeholder={(is2T&&numC>=2)?"Limite atingido":`Candidato a ${cargo}`} style={{flex:1}} onKeyDown={e=>e.key==="Enter"&&addCand(cargo)}/>
                  <Btn onClick={()=>addCand(cargo)} disabled={!(novoCand[cargo]||"").trim()||(is2T&&numC>=2)} small>+ Add</Btn>
                </div>
                <div>{(candidatos[cargo]||[]).map((c,i)=><Tag key={i} label={<><span style={{width:8,height:8,borderRadius:"50%",background:cor(i),display:"inline-block",marginRight:6}}/>{c}</>} onRemove={()=>delCand(cargo,i)}/>)}</div>
              </Card>
            );
          })}

          <Btn full onClick={()=>onIniciar({nome,tipo,regioes,cargos,candidatos,perguntas})} disabled={!ok}>Criar Pesquisa →</Btn>

          {/* Perguntas personalizadas */}
          <Card style={{marginTop:14,marginBottom:14}}>
            <Lbl>❓ Perguntas personalizadas</Lbl>
            <p style={{color:"#445577",fontSize:12,marginBottom:12}}>Opcional · Perguntas extras para a pesquisa</p>
            <div style={{display:"flex",gap:8,marginBottom:12}}>
              <Inp value={novaPergunta} onChange={setNovaPergunta} placeholder="Ex: Como você avalia a gestão atual?" style={{flex:1}} onKeyDown={e=>e.key==="Enter"&&addPergunta()}/>
              <Btn onClick={addPergunta} disabled={!novaPergunta.trim()} small>+ Add</Btn>
            </div>
            {perguntas.map((pg,pi)=>(
              <div key={pi} style={{background:"#07101f",border:"1px solid #1a2b47",borderRadius:10,padding:12,marginBottom:10}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8}}>
                  <span style={{color:"#c0d0f0",fontSize:13,fontWeight:600}}>{pg.texto}</span>
                  <button onClick={()=>delPergunta(pi)} style={{background:"none",border:"none",color:"#ff4d6d",cursor:"pointer",fontSize:16}}>×</button>
                </div>
                <div style={{color:"#7799bb",fontSize:11,fontWeight:700,marginBottom:6}}>OPÇÕES DE RESPOSTA</div>
                <div style={{display:"flex",flexWrap:"wrap",gap:6,marginBottom:8}}>
                  {OPCOES_PADRAO.map(op=>(
                    <button key={op} onClick={()=>addOpcaoPergunta(pi,op)}
                      style={{padding:"4px 10px",borderRadius:20,border:"1px solid #1a2b47",background:pg.opcoes.includes(op)?"#00e67622":"#0d1829",color:pg.opcoes.includes(op)?"#00e676":"#445577",fontSize:12,cursor:"pointer"}}>
                      {op}
                    </button>
                  ))}
                </div>
                <div style={{display:"flex",gap:8,marginBottom:6}}>
                  <Inp value={novasOpcoes[pi]||""} onChange={v=>setNovasOpcoes(o=>({...o,[pi]:v}))} placeholder="Opção personalizada..." style={{flex:1}} onKeyDown={e=>e.key==="Enter"&&addOpcaoPergunta(pi)}/>
                  <Btn onClick={()=>addOpcaoPergunta(pi)} disabled={!(novasOpcoes[pi]||"").trim()} small>+ Add</Btn>
                </div>
                <div style={{display:"flex",flexWrap:"wrap",gap:4}}>
                  {pg.opcoes.map((op,oi)=><Tag key={oi} label={op} onRemove={()=>delOpcaoPergunta(pi,oi)}/>)}
                </div>
                {pg.opcoes.length===0&&<p style={{color:"#2a3d5a",fontSize:11,marginTop:4}}>Adicione ao menos uma opção de resposta.</p>}
              </div>
            ))}
          </Card>
        </>}
      </div>
    </div>
  );
}

// ─── Coleta ───────────────────────────────────────────────────────────────────
function TelaColeta({config, entrevistas, isPro, onSalvar, onResultados}) {
  const tipo = TIPOS[config?.tipo];
  const cargos=(config?.cargos||[]).filter(c=>(config.candidatos[c]||[]).length>0&&!CARGOS_2T_FIXO.includes(c));
  const cargos2T=(config?.cargos||[]).filter(c=>CARGOS_2T_FIXO.includes(c)&&(config.candidatos[c]||[]).length>=2);
  const hasProblemas=isPro&&tipo?.problemas;
  const has2T=cargos2T.length>0;
  const hasPerguntas=(config?.perguntas||[]).length>0;
  // Ordem: perfil → perguntas → votos → rejeição → problemas → 2ºturno
  const totalSteps=1+(hasPerguntas?1:0)+cargos.length+1+(hasProblemas?1:0)+(has2T?1:0);
  const stepPerguntas = hasPerguntas ? 1 : -1;
  const stepVotosInicio = 1 + (hasPerguntas?1:0);
  const stepRejeicao = stepVotosInicio + cargos.length;
  const stepProblemas = hasProblemas ? stepRejeicao+1 : -1;
  const step2T = has2T ? stepRejeicao+(hasProblemas?2:1) : -1;

  const [step,setStep]=useState(0);
  const [perfil,setPerfil]=useState({sexo:"",idade:"",regiao:""});
  const [votos,setVotos]=useState({});
  const [rejeicoes,setRejeicoes]=useState({});
  const [problemas,setProblemas]=useState([]);
  const [votos2T,setVotos2T]=useState({});
  const [respostasPerguntas,setRespostasPerguntas]=useState({});
  const [salvando,setSalvando]=useState(false);
  const [toast,setToast]=useState("");

  const showToast=m=>{setToast(m);setTimeout(()=>setToast(""),2200);};
  const sc=step-stepVotosInicio;
  const isPerguntas=hasPerguntas&&step===stepPerguntas;
  const isRejeicao=step===stepRejeicao;
  const isProblemas=hasProblemas&&step===stepProblemas;
  const is2T=has2T&&step===step2T;

  const finalizar=async()=>{
    const e={id:Date.now(),data:new Date().toISOString(),perfil,votos,rejeicoes,problemas,votos2T,respostasPerguntas};
    setSalvando(true);
    if(onSalvar) await onSalvar(e);
    setPerfil({sexo:"",idade:"",regiao:""});setVotos({});setRejeicoes({});setProblemas([]);setVotos2T({});setRespostasPerguntas({});setStep(0);
    setSalvando(false);showToast("✅ Entrevista registrada!");
  };

  const avancar=()=>step<totalSteps-1?setStep(s=>s+1):finalizar();
  const podeAvancar=()=>{
    if(step===0){
      if(isPro) return !!(perfil.sexo&&perfil.idade&&perfil.regiao);
      return true;
    }
    if(step>=stepVotosInicio&&step<stepRejeicao) return !!votos[cargos[sc]];
    return true;
  };

  const titulo=()=>{
    if(step===0) return isPro?"Perfil do Entrevistado":"Iniciar Entrevista";
    if(isPerguntas) return "❓ Perguntas Extras";
    if(step>=stepVotosInicio&&step<stepRejeicao) return `Voto: ${cargos[sc]}`;
    if(isRejeicao) return "Rejeição";
    if(isProblemas) return "Problemas da Cidade";
    return "🔁 Segundo Turno";
  };

  const opcoesCargo=cargo=>[
    ...(config.candidatos[cargo]||[]).map((n,i)=>({nome:n,cor:cor(i)})),
    {nome:"Branco/Nulo",cor:"#445577"},{nome:"Indeciso/Não sabe",cor:"#664488"},
  ];

  return (
    <div>
      <div style={{display:"flex",gap:4,marginBottom:22}}>
        {Array.from({length:totalSteps}).map((_,i)=><div key={i} style={{flex:1,height:4,borderRadius:2,background:i<=step?"#00e676":"#1a2b47",transition:"background .3s"}}/>)}
      </div>
      <div style={{display:"flex",justifyContent:"space-between",marginBottom:18}}>
        <div><h2 style={S.h2}>{titulo()}</h2><p style={S.sub}>{config.nome} · Entrevista #{entrevistas.length+1}</p></div>
        <span style={{color:"#445577",fontSize:12,fontFamily:"monospace",marginTop:4}}>{step+1}/{totalSteps}</span>
      </div>

      {step===0 && (
        isPro ? (
          <Card>
            <Lbl>Sexo</Lbl>
            <div style={{display:"flex",gap:8,marginBottom:16}}>
              {["Masculino","Feminino","Outro"].map(s=><button key={s} onClick={()=>setPerfil(p=>({...p,sexo:s}))} style={{flex:1,padding:"11px 8px",borderRadius:10,border:`2px solid ${perfil.sexo===s?"#00e676":"#1a2b47"}`,background:perfil.sexo===s?"#001a0f":"#07101f",color:perfil.sexo===s?"#00e676":"#7799bb",fontFamily:"'Sora',sans-serif",fontWeight:600,cursor:"pointer",fontSize:12}}>{s}</button>)}
            </div>
            <Lbl>Faixa etária</Lbl>
            <div style={{display:"flex",flexWrap:"wrap",gap:8,marginBottom:16}}>
              {["16-24","25-34","35-44","45-59","60+"].map(f=><button key={f} onClick={()=>setPerfil(p=>({...p,idade:f}))} style={{padding:"9px 14px",borderRadius:10,border:`2px solid ${perfil.idade===f?"#00e676":"#1a2b47"}`,background:perfil.idade===f?"#001a0f":"#07101f",color:perfil.idade===f?"#00e676":"#7799bb",fontFamily:"'Sora',sans-serif",fontWeight:600,cursor:"pointer",fontSize:13}}>{f}</button>)}
            </div>
            <Lbl>Região / Bairro</Lbl>
            <div style={{display:"flex",flexDirection:"column",gap:8}}>
              {(config.regioes||[]).map(r=><button key={r} onClick={()=>setPerfil(p=>({...p,regiao:r}))} style={{padding:"11px 14px",borderRadius:10,border:`2px solid ${perfil.regiao===r?"#00e676":"#1a2b47"}`,background:perfil.regiao===r?"#001a0f":"#07101f",color:perfil.regiao===r?"#00e676":"#a0b8d8",fontFamily:"'Sora',sans-serif",fontWeight:600,cursor:"pointer",textAlign:"left",fontSize:14}}>📍 {r}</button>)}
            </div>
          </Card>
        ) : (
          <Card>
            <div style={{textAlign:"center",padding:"20px 0"}}>
              <div style={{fontSize:48,marginBottom:12}}>📋</div>
              <p style={{color:"#7799bb",fontSize:14}}>Pronto para registrar a entrevista.<br/>Clique em Próximo para começar.</p>
            </div>
          </Card>
        )
      )}

      {step>=stepVotosInicio&&step<stepRejeicao&&(
        <Card>
          <Lbl>Intenção de voto — {cargos[sc]}</Lbl>
          <div style={{display:"flex",flexDirection:"column",gap:10,marginTop:8}}>
            {opcoesCargo(cargos[sc]).map((op,i)=>{const sel=votos[cargos[sc]]===op.nome;return<button key={i} onClick={()=>setVotos(p=>({...p,[cargos[sc]]:op.nome}))} style={{padding:"13px 16px",borderRadius:11,border:`2px solid ${sel?op.cor:"#1a2b47"}`,background:sel?`${op.cor}18`:"#07101f",color:sel?op.cor:"#a0b8d8",fontFamily:"'Sora',sans-serif",fontWeight:600,cursor:"pointer",textAlign:"left",fontSize:14,transition:"all .15s"}}><span style={{width:10,height:10,borderRadius:"50%",background:op.cor,display:"inline-block",marginRight:10}}/>{op.nome}</button>;})}
          </div>
        </Card>
      )}

      {isRejeicao&&(
        <Card>
          <Lbl>Qual candidato NÃO votaria?</Lbl>
          <p style={{color:"#445577",fontSize:12,marginBottom:14}}>Opcional — pode pular.</p>
          {cargos.map(cargo=>(
            <div key={cargo} style={{marginBottom:16}}>
              <div style={{color:"#7799bb",fontSize:12,fontWeight:700,marginBottom:8}}>{cargo}</div>
              <div style={{display:"flex",flexWrap:"wrap",gap:8}}>
                {[...(config.candidatos[cargo]||[]),"Nenhum"].map(nome=>{const sel=rejeicoes[cargo]===nome;return<button key={nome} onClick={()=>setRejeicoes(p=>({...p,[cargo]:nome}))} style={{padding:"8px 14px",borderRadius:20,border:`1.5px solid ${sel?"#ff4d6d":"#1a2b47"}`,background:sel?"#ff4d6d22":"#07101f",color:sel?"#ff4d6d":"#7799bb",fontFamily:"'Sora',sans-serif",fontWeight:600,cursor:"pointer",fontSize:13}}>{nome}</button>;})}
              </div>
            </div>
          ))}
        </Card>
      )}

      {isProblemas&&(
        <Card>
          <Lbl>Principais problemas da cidade</Lbl>
          <p style={{color:"#445577",fontSize:12,marginBottom:14}}>Opcional · Múltipla escolha.</p>
          <div style={{display:"flex",flexWrap:"wrap",gap:8}}>
            {PROBLEMAS_LIST.map(p=>{const sel=problemas.includes(p);return<button key={p} onClick={()=>setProblemas(prev=>sel?prev.filter(x=>x!==p):[...prev,p])} style={{padding:"9px 16px",borderRadius:20,border:`1.5px solid ${sel?"#f7c948":"#1a2b47"}`,background:sel?"#f7c94822":"#07101f",color:sel?"#f7c948":"#7799bb",fontFamily:"'Sora',sans-serif",fontWeight:600,cursor:"pointer",fontSize:13}}>{p}</button>;})}
          </div>
        </Card>
      )}

      {is2T&&(
        <Card>
          <Lbl>🔁 Segundo Turno — hipótese</Lbl>
          <p style={{color:"#445577",fontSize:12,marginBottom:16}}>Opcional · Se houvesse segundo turno, em quem votaria?</p>
          {cargos2T.map(cargo=>{
            const cands=(config.candidatos[cargo]||[]).slice(0,2);
            return<div key={cargo} style={{marginBottom:20}}>
              <div style={{color:"#7799bb",fontSize:12,fontWeight:700,marginBottom:10}}>{cargo.replace(" 2º Turno","")}</div>
              <div style={{display:"flex",flexDirection:"column",gap:8}}>
                {[...cands.map((n,i)=>({nome:n,cor:cor(i)})),{nome:"Branco/Nulo",cor:"#445577"},{nome:"Indeciso/Não sabe",cor:"#664488"}].map((op,i)=>{const sel=votos2T[cargo]===op.nome;return<button key={i} onClick={()=>setVotos2T(p=>({...p,[cargo]:op.nome}))} style={{padding:"13px 16px",borderRadius:11,border:`2px solid ${sel?op.cor:"#1a2b47"}`,background:sel?`${op.cor}18`:"#07101f",color:sel?op.cor:"#a0b8d8",fontFamily:"'Sora',sans-serif",fontWeight:600,cursor:"pointer",textAlign:"left",fontSize:14,transition:"all .15s"}}><span style={{width:10,height:10,borderRadius:"50%",background:op.cor,display:"inline-block",marginRight:10}}/>{op.nome}</button>;})}
              </div>
            </div>;
          })}
        </Card>
      )}

      {isPerguntas&&(
        <Card>
          <Lbl>❓ Perguntas Extras</Lbl>
          <p style={{color:"#445577",fontSize:12,marginBottom:16}}>Opcional · Pode pular.</p>
          {(config.perguntas||[]).map((pg,pi)=>(
            <div key={pi} style={{marginBottom:18}}>
              <div style={{color:"#c0d0f0",fontSize:14,fontWeight:600,marginBottom:8}}>{pg.texto}</div>
              <div style={{display:"flex",flexWrap:"wrap",gap:8}}>
                {pg.opcoes.map(op=>{
                  const sel=respostasPerguntas[pi]===op;
                  return <button key={op} onClick={()=>setRespostasPerguntas(r=>({...r,[pi]:op}))}
                    style={{padding:"8px 14px",borderRadius:20,border:`1.5px solid ${sel?"#4488ff":"#1a2b47"}`,background:sel?"#4488ff22":"#07101f",color:sel?"#4488ff":"#7799bb",fontFamily:"'Sora',sans-serif",fontWeight:600,cursor:"pointer",fontSize:13}}>{op}</button>;
                })}
              </div>
            </div>
          ))}
        </Card>
      )}

      <div style={{display:"flex",gap:10,marginTop:16}}>
        {step>0&&<Btn variant="secondary" onClick={()=>setStep(s=>s-1)}>← Voltar</Btn>}
        <Btn full onClick={avancar} disabled={!podeAvancar()||salvando}>{salvando?"Salvando...":(step===totalSteps-1?"Finalizar Entrevista ✓":"Próximo →")}</Btn>
      </div>
      {onResultados&&entrevistas.length>=30&&<Btn full variant="secondary" onClick={onResultados} style={{marginTop:10}}>Ver Resultados ({entrevistas.length}) →</Btn>}
      {entrevistas.length>0&&entrevistas.length<30&&<p style={{color:"#334466",fontSize:12,textAlign:"center",marginTop:10}}>{entrevistas.length} entrevistas · Recomendado: 30+</p>}
      <Toast msg={toast}/>
    </div>
  );
}

// ─── Banner Upgrade Pro (para usuários Analytics) ─────────────────────────────
const LINK_UPGRADE_PRO = "https://www.mercadopago.com.br/subscriptions/checkout?preapproval_plan_id=64bb516034004e99bea5a53248d18596";

function BannerUpgradePro() {
  return (
    <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",gap:12,background:"#0d1829",border:"1px solid #1a2b47",borderRadius:10,padding:"12px 18px",marginBottom:16,flexWrap:"wrap"}}>
      <span style={{color:"#7799bb",fontSize:13}}>
        🏆 Utilize todos os recursos com o <span style={{color:"#00e676",fontWeight:700}}>VotôMetro Pro</span> — pesquisas municipais, perfil do eleitor, análise regional e muito mais.
      </span>
      <button onClick={()=>window.open(LINK_UPGRADE_PRO,"_blank")} style={{background:"linear-gradient(135deg,#00c956,#00e676)",color:"#07101f",fontFamily:"'Sora',sans-serif",fontWeight:700,fontSize:12,padding:"7px 16px",borderRadius:8,border:"none",cursor:"pointer",whiteSpace:"nowrap"}}>
        Assinar Pro R$99,90/mês →
      </button>
    </div>
  );
}

// ─── Resultados ───────────────────────────────────────────────────────────────
function TelaResultados({config, entrevistas, isPro, onVoltar}) {
  const tipo=TIPOS[config?.tipo];
  const cargos=(config?.cargos||[]).filter(c=>(config.candidatos[c]||[]).length>0&&!CARGOS_2T_FIXO.includes(c));
  const cargos2T=(config?.cargos||[]).filter(c=>CARGOS_2T_FIXO.includes(c)&&(config.candidatos[c]||[]).length>=2);
  const [cargoAtivo,setCargoAtivo]=useState(cargos[0]);
  const [aba,setAba]=useState("geral");
  const total=entrevistas.length;

  const opcoes=[...(config.candidatos[cargoAtivo]||[]).map((n,i)=>({nome:n,cor:cor(i)})),{nome:"Branco/Nulo",cor:"#445577"},{nome:"Indeciso/Não sabe",cor:"#664488"}];
  const stats=calcStats(opcoes.map(op=>({...op,count:entrevistas.filter(e=>e.votos?.[cargoAtivo]===op.nome).length})),total);
  const win=winner(stats);
  const indecisos=entrevistas.filter(e=>e.votos?.[cargoAtivo]==="Indeciso/Não sabe");
  const cands=stats.filter(s=>!["Branco/Nulo","Indeciso/Não sabe"].includes(s.nome));

  const porGrupo=(campo,grupos,cand)=>grupos.map(g=>{const sub=entrevistas.filter(e=>e.perfil?.[campo]===g);return{g,pct:sub.length?+((sub.filter(e=>e.votos?.[cargoAtivo]===cand).length/sub.length)*100).toFixed(1):0,n:sub.length};}).filter(x=>x.n>0);
  const rejeicao=(config.candidatos[cargoAtivo]||[]).map((nome,i)=>({nome,cor:cor(i),count:entrevistas.filter(e=>e.rejeicoes?.[cargoAtivo]===nome).length})).sort((a,b)=>b.count-a.count);
  const problemasCont=PROBLEMAS_LIST.map((p,i)=>({nome:p,cor:cor(i),count:entrevistas.filter(e=>(e.problemas||[]).includes(p)).length})).sort((a,b)=>b.count-a.count);
  const has2TData=cargos2T.length>0&&entrevistas.some(e=>Object.keys(e.votos2T||{}).length>0);
  const hasOpiniao=(config?.perguntas||[]).length>0&&entrevistas.some(e=>e.respostas_perguntas&&Object.keys(e.respostas_perguntas).length>0);

  const exportCSV=()=>{
    const rows=[["Data","Sexo","Idade","Região",...cargos.map(c=>`Voto_${c}`),...cargos.map(c=>`Rejeicao_${c}`),...(tipo?.problemas&&isPro?["Problemas"]:[])]];
    entrevistas.forEach(e=>rows.push([e.data?.slice(0,10),e.perfil?.sexo||"",e.perfil?.idade||"",e.perfil?.regiao||"",...cargos.map(c=>e.votos?.[c]||""),...cargos.map(c=>e.rejeicoes?.[c]||""),...(tipo?.problemas&&isPro?[(e.problemas||[]).join("|")]:[])]));
    const b=new Blob([rows.map(r=>r.join(";")).join("\n")],{type:"text/csv;charset=utf-8;"});
    const a=document.createElement("a");a.href=URL.createObjectURL(b);a.download=`${config.nome}.csv`;a.click();
  };

  const abas=[["geral","📊 Geral"],...(isPro?[["perfil","👤 Perfil"],["regioes","📍 Regiões"]]:[]),["rejeicao","❌ Rejeição"],...(tipo?.problemas&&isPro?[["problemas","🏙️ Problemas"]]:[]),...(has2TData?[["segundoturno","🔁 2º Turno"]]:[]),...(hasOpiniao?[["opiniao","💬 Pesquisa de Opinião"]]:[])];

  return (
    <div>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:20}}>
        <div><h2 style={S.h2}>Resultados</h2><p style={S.sub}>{config.nome} · {total} entrevistas</p></div>
        <div style={{display:"flex",gap:8}}>
          <Btn small variant="secondary" onClick={exportCSV}>⬇ CSV</Btn>
          {onVoltar&&<Btn small variant="secondary" onClick={onVoltar}>← Voltar</Btn>}
        </div>
      </div>

      <div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:18}}>
        {cargos.map(c=><button key={c} onClick={()=>{setCargoAtivo(c);setAba("geral");}} style={{padding:"7px 14px",borderRadius:20,border:`1.5px solid ${cargoAtivo===c?"#00e676":"#1a2b47"}`,background:cargoAtivo===c?"#001a0f":"#07101f",color:cargoAtivo===c?"#00e676":"#7799bb",fontFamily:"'Sora',sans-serif",fontWeight:600,cursor:"pointer",fontSize:13}}>{c}</button>)}
      </div>

      <div style={{display:"flex",borderBottom:"1px solid #1a2b47",marginBottom:20,overflowX:"auto"}}>
        {abas.map(([id,label])=><button key={id} onClick={()=>setAba(id)} style={{background:"none",border:"none",borderBottom:`2px solid ${aba===id?"#00e676":"transparent"}`,color:aba===id?"#00e676":"#445577",fontFamily:"'Sora',sans-serif",fontWeight:600,fontSize:13,padding:"8px 14px",cursor:"pointer",whiteSpace:"nowrap"}}>{label}</button>)}
      </div>

      {total<2?<Card style={{textAlign:"center",padding:40,color:"#445577"}}><div style={{fontSize:40}}>📋</div><p style={{marginTop:12}}>Colete ao menos 2 entrevistas.</p></Card>:<>

        {aba==="geral"&&<>
          {win&&<div style={{background:"linear-gradient(135deg,#001a0f,#001428)",border:"1.5px solid #00e676",borderRadius:14,padding:"18px 22px",marginBottom:18}}>
            <div style={{color:"#8899bb",fontSize:11,marginBottom:4}}>🏆 PROJEÇÃO — {cargoAtivo}</div>
            <div style={{fontSize:20,fontWeight:800,color:"#fff"}}>{win.nome}</div>
            <div style={{display:"flex",gap:10,alignItems:"center",marginTop:4}}><span style={{fontSize:28,fontWeight:800,color:"#00e676"}}>{win.pct}%</span><span style={{background:win.empate?"linear-gradient(135deg,#ff4d6d,#c9184a)":"linear-gradient(135deg,#ffd700,#ff8c00)",color:win.empate?"#fff":"#07101f",fontSize:10,fontWeight:700,padding:"3px 9px",borderRadius:20}}>{win.empate?"Empate Técnico":"Vencedor Projetado"}</span></div>
            <div style={{color:"#334466",fontSize:11,marginTop:4,fontFamily:"monospace"}}>IC 95%: [{win.min}% – {win.max}%] · ±{win.erro}%</div>
          </div>}
          {stats.map((st,i)=><Card key={st.nome} style={{marginBottom:10,padding:"14px 18px"}}>
            <div style={{display:"flex",justifyContent:"space-between",marginBottom:6}}><div style={{display:"flex",alignItems:"center",gap:8}}><div style={{width:10,height:10,borderRadius:"50%",background:st.cor||cor(i)}}/><span style={{color:"#c0d0f0",fontWeight:600}}>{st.nome}</span></div><span style={{color:"#00e676",fontFamily:"monospace",fontWeight:700}}>{st.pct}%</span></div>
            <Bar pct={st.pct} color={st.cor||cor(i)}/>
            <div style={{display:"flex",gap:14,fontSize:11,color:"#334466",fontFamily:"monospace",marginTop:6}}><span>n={st.count}</span><span>±{st.erro}%</span><span>IC:[{st.min}%–{st.max}%]</span></div>
          </Card>)}
        </>}

        {aba==="perfil"&&isPro&&<>
          <Card style={{marginBottom:14}}><Lbl>Indecisos</Lbl><div style={{fontSize:26,fontWeight:800,color:"#f7c948"}}>{total?+((indecisos.length/total)*100).toFixed(1):0}%</div><div style={{color:"#445577",fontSize:13,marginTop:4}}>{indecisos.length} de {total}</div></Card>
          {cands.map((st,i)=><Card key={st.nome} style={{marginBottom:12}}>
            <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:10}}><div style={{width:10,height:10,borderRadius:"50%",background:st.cor||cor(i)}}/><span style={{color:"#fff",fontWeight:700}}>{st.nome}</span><span style={{color:"#00e676",fontFamily:"monospace",marginLeft:"auto"}}>{st.pct}%</span></div>
            <div style={{color:"#7799bb",fontSize:11,marginBottom:6}}>POR SEXO</div>
            {porGrupo("sexo",["Masculino","Feminino","Outro"],st.nome).map(({g,pct,n})=><div key={g} style={{marginBottom:8}}><div style={{display:"flex",justifyContent:"space-between",fontSize:12,color:"#7799bb",marginBottom:3}}><span>{g}</span><span>{pct}% (n={n})</span></div><Bar pct={pct} color={st.cor||cor(i)}/></div>)}
            <div style={{color:"#7799bb",fontSize:11,margin:"10px 0 6px"}}>POR FAIXA ETÁRIA</div>
            {porGrupo("idade",["16-24","25-34","35-44","45-59","60+"],st.nome).map(({g,pct,n})=><div key={g} style={{marginBottom:8}}><div style={{display:"flex",justifyContent:"space-between",fontSize:12,color:"#7799bb",marginBottom:3}}><span>{g}</span><span>{pct}% (n={n})</span></div><Bar pct={pct} color={st.cor||cor(i)}/></div>)}
          </Card>)}
        </>}

        {aba==="regioes"&&isPro&&cands.map((st,i)=><Card key={st.nome} style={{marginBottom:12}}>
          <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:10}}><div style={{width:10,height:10,borderRadius:"50%",background:st.cor||cor(i)}}/><span style={{color:"#fff",fontWeight:700}}>{st.nome}</span><span style={{color:"#00e676",fontFamily:"monospace",marginLeft:"auto"}}>{st.pct}% geral</span></div>
          {porGrupo("regiao",config.regioes||[],st.nome).map(({g,pct,n})=><div key={g} style={{marginBottom:8}}><div style={{display:"flex",justifyContent:"space-between",fontSize:12,color:"#7799bb",marginBottom:3}}><span>📍 {g}</span><span style={{color:pct>=st.pct+5?"#00e676":pct<=st.pct-5?"#ff4d6d":"#7799bb"}}>{pct}% (n={n}){pct>=st.pct+5?" 💪":pct<=st.pct-5?" ⚠️":""}</span></div><Bar pct={pct} color={pct>=st.pct?st.cor||cor(i):"#334466"}/></div>)}
        </Card>)}

        {aba==="rejeicao"&&<Card><Lbl>Rejeição — {cargoAtivo}</Lbl>{rejeicao.every(r=>r.count===0)?<p style={{color:"#445577",fontSize:13}}>Sem dados.</p>:rejeicao.map((r)=><div key={r.nome} style={{marginBottom:12}}><div style={{display:"flex",justifyContent:"space-between",fontSize:13,marginBottom:3}}><div style={{display:"flex",alignItems:"center",gap:8}}><div style={{width:8,height:8,borderRadius:"50%",background:r.cor}}/><span style={{color:"#c0d0f0"}}>{r.nome}</span></div><span style={{color:"#ff4d6d",fontFamily:"monospace"}}>{total?+((r.count/total)*100).toFixed(1):0}%</span></div><Bar pct={total?(r.count/total)*100:0} color="#ff4d6d"/></div>)}</Card>}

        {aba==="problemas"&&isPro&&<Card><Lbl>Problemas da Cidade</Lbl>{problemasCont.every(p=>p.count===0)?<p style={{color:"#445577",fontSize:13}}>Sem dados.</p>:problemasCont.map(p=><div key={p.nome} style={{marginBottom:12}}><div style={{display:"flex",justifyContent:"space-between",fontSize:13,marginBottom:3}}><span style={{color:"#c0d0f0"}}>{p.nome}</span><span style={{color:p.cor,fontFamily:"monospace"}}>{total?+((p.count/total)*100).toFixed(1):0}%</span></div><Bar pct={total?(p.count/total)*100:0} color={p.cor}/></div>)}</Card>}

        {aba==="segundoturno"&&cargos2T.map(cargo=>{
          const totalR=entrevistas.filter(e=>e.votos2T?.[cargo]).length;
          const opts=[...(config.candidatos[cargo]||[]).slice(0,2).map((n,i)=>({nome:n,cor:cor(i)})),{nome:"Branco/Nulo",cor:"#445577"},{nome:"Indeciso/Não sabe",cor:"#664488"}];
          const st2=calcStats(opts.map(op=>({...op,count:entrevistas.filter(e=>e.votos2T?.[cargo]===op.nome).length})),totalR);
          const w2=winner(st2);
          return<div key={cargo} style={{marginBottom:24}}>
            <div style={{color:"#7799bb",fontSize:13,fontWeight:700,marginBottom:12}}>🔁 {cargo.replace(" 2º Turno","")} — 2º Turno</div>
            {totalR<2?<Card><p style={{color:"#445577",fontSize:13}}>Dados insuficientes.</p></Card>:<>
              {w2&&<div style={{background:"linear-gradient(135deg,#001428,#000d1f)",border:"1.5px solid #4488ff",borderRadius:14,padding:"16px 20px",marginBottom:14}}><div style={{color:"#8899bb",fontSize:11,marginBottom:4}}>🏆 PROJEÇÃO 2º TURNO</div><div style={{fontSize:18,fontWeight:800,color:"#fff"}}>{w2.nome}</div><div style={{display:"flex",gap:10,alignItems:"center",marginTop:4}}><span style={{fontSize:26,fontWeight:800,color:"#4488ff"}}>{w2.pct}%</span><span style={{background:w2.empate?"linear-gradient(135deg,#ff4d6d,#c9184a)":"linear-gradient(135deg,#4488ff,#0044cc)",color:"#fff",fontSize:10,fontWeight:700,padding:"3px 9px",borderRadius:20}}>{w2.empate?"Empate Técnico":"Vencedor Projetado"}</span></div><div style={{color:"#334466",fontSize:11,marginTop:4,fontFamily:"monospace"}}>IC 95%: [{w2.min}% – {w2.max}%] · n={totalR}</div></div>}
              {st2.map((st,i)=><Card key={st.nome} style={{marginBottom:10,padding:"14px 18px"}}><div style={{display:"flex",justifyContent:"space-between",marginBottom:6}}><div style={{display:"flex",alignItems:"center",gap:8}}><div style={{width:10,height:10,borderRadius:"50%",background:st.cor||cor(i)}}/><span style={{color:"#c0d0f0",fontWeight:600}}>{st.nome}</span></div><span style={{color:"#4488ff",fontFamily:"monospace",fontWeight:700}}>{st.pct}%</span></div><Bar pct={st.pct} color={st.cor||cor(i)}/></Card>)}
            </>}
          </div>;
        })}
        {aba==="opiniao"&&<div>
          {(config.perguntas||[]).map((pg,pi)=>{
            const resps=entrevistas.map(e=>(e.respostas_perguntas||{})[pi]).filter(Boolean);
            const totalR=resps.length;
            if(!totalR) return null;
            const contagem=pg.opcoes.map((op,oi)=>({
              nome:op, cor:cor(oi),
              count:resps.filter(r=>r===op).length
            })).sort((a,b)=>b.count-a.count);
            return <Card key={pi} style={{marginBottom:14}}>
              <Lbl>{pg.texto}</Lbl>
              <div style={{color:"#445577",fontSize:11,marginBottom:10}}>{totalR} respostas</div>
              {contagem.map((c,i)=>{
                const pct=totalR?+((c.count/totalR)*100).toFixed(1):0;
                return <div key={i} style={{marginBottom:10}}>
                  <div style={{display:"flex",justifyContent:"space-between",fontSize:13,marginBottom:4}}>
                    <div style={{display:"flex",alignItems:"center",gap:8}}>
                      <div style={{width:8,height:8,borderRadius:"50%",background:c.cor}}/>
                      <span style={{color:"#c0d0f0"}}>{c.nome}</span>
                    </div>
                    <span style={{color:c.cor,fontFamily:"monospace",fontWeight:700}}>{pct}%</span>
                  </div>
                  <Bar pct={pct} color={c.cor}/>
                  <div style={{fontSize:11,color:"#334466",fontFamily:"monospace",marginTop:3}}>n={c.count}</div>
                </div>;
              })}
            </Card>;
          })}
        </div>}

      </>}
    </div>
  );
}

// ─── Política de Privacidade ──────────────────────────────────────────────────
function PoliticaPrivacidade() {
  return (
    <div style={{minHeight:"100vh",background:"#07101f",fontFamily:"'Sora',sans-serif",color:"#d0e0ff"}}>
      <style>{CSS}</style>
      <nav style={{background:"#0b1527",borderBottom:"1px solid #1a2b47",padding:"14px 24px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
        <div style={{fontSize:18,fontWeight:800}}>🗳️ <span style={{background:"linear-gradient(90deg,#00e676,#4488ff)",WebkitBackgroundClip:"text",WebkitTextFillColor:"transparent"}}>VotôMetro</span></div>
        <a href="/" style={{color:"#445577",fontSize:13,textDecoration:"none"}}>← Voltar</a>
      </nav>
      <div style={{maxWidth:720,margin:"0 auto",padding:"40px 24px 80px"}}>
        <h1 style={{fontSize:28,fontWeight:800,color:"#fff",marginBottom:8}}>Política de Privacidade</h1>
        <p style={{color:"#445577",fontSize:13,marginBottom:32}}>Última atualização: maio de 2026</p>

        {[
          ["1. Introdução", "O VotôMetro é um aplicativo de pesquisa eleitoral profissional desenvolvido por Fábio Bomfim. Esta Política de Privacidade descreve como coletamos, usamos e protegemos suas informações ao usar nosso aplicativo e site (votometro.live)."],
          ["2. Informações que Coletamos", "Coletamos informações de cadastro (nome, e-mail, senha e plano), dados de pesquisa (intenções de voto, perfil dos entrevistados, respostas a perguntas personalizadas e data/hora das entrevistas) e dados de uso (informações de acesso e tipo de dispositivo)."],
          ["3. Como Usamos suas Informações", "Utilizamos suas informações para fornecer e melhorar nossos serviços, processar pagamentos e gerenciar assinaturas, enviar comunicações relacionadas ao serviço e gerar relatórios e estatísticas das pesquisas."],
          ["4. Compartilhamento de Dados", "Não vendemos, alugamos ou compartilhamos suas informações pessoais com terceiros, exceto com: Mercado Pago (processamento de pagamentos), Supabase (armazenamento seguro dos dados), Resend (envio de e-mails transacionais) e quando exigido por lei ou autoridade competente."],
          ["5. Segurança dos Dados", "Adotamos medidas técnicas e organizacionais para proteger suas informações contra acesso não autorizado, alteração, divulgação ou destruição. Os dados são armazenados em servidores seguros com criptografia."],
          ["6. Retenção de Dados", "Seus dados são mantidos enquanto sua conta estiver ativa. Ao cancelar sua assinatura e solicitar a exclusão da conta, seus dados serão removidos em até 30 dias."],
          ["7. Seus Direitos (LGPD)", "De acordo com a Lei Geral de Proteção de Dados (LGPD — Lei 13.709/2018), você tem direito a acessar, corrigir ou excluir seus dados pessoais, além de revogar o consentimento a qualquer momento. Entre em contato: votometro.live@gmail.com"],
          ["8. Dados dos Entrevistados", "Os dados coletados durante as pesquisas são de responsabilidade do pesquisador que utiliza o VotôMetro. Os entrevistados devem ser informados sobre a coleta de dados antes da entrevista."],
          ["9. Cookies e Tecnologias Similares", "Utilizamos armazenamento local (localStorage) para manter sua sessão ativa no aplicativo. Não utilizamos cookies de rastreamento ou publicidade."],
          ["10. Menores de Idade", "O VotôMetro não é destinado a menores de 18 anos. Não coletamos intencionalmente dados de menores."],
          ["11. Contato", "Para dúvidas sobre esta Política de Privacidade: Fábio Bomfim · votometro.live@gmail.com · https://votometro.live"],
        ].map(([titulo, texto])=>(
          <div key={titulo} style={{marginBottom:28}}>
            <h2 style={{fontSize:16,fontWeight:700,color:"#00e676",marginBottom:8}}>{titulo}</h2>
            <p style={{color:"#7799bb",fontSize:14,lineHeight:1.7}}>{texto}</p>
          </div>
        ))}
      </div>
      <div style={{textAlign:"center",padding:"20px 24px",color:"#334466",fontSize:12,borderTop:"1px solid #1a2b47"}}>
        © 2026 VotôMetro · Fábio Bomfim · votometro.live@gmail.com
      </div>
    </div>
  );
}

// ─── App Root ─────────────────────────────────────────────────────────────────
export default function App() {
  const [screen, setScreen] = useState("loading");
  const [user, setUser] = useState(null);
  const [linkId, setLinkId] = useState(null);

  useEffect(()=>{
    const params=new URLSearchParams(window.location.search);
    const coleta=params.get("coleta");
    if(coleta){setLinkId(coleta);setScreen("coleta_publica");return;}
    // Rota para política de privacidade
    if(window.location.pathname==="/politica-de-privacidade"){setScreen("privacidade");return;}
    const s=localStorage.getItem("vm_session");
    if(s){try{setUser(JSON.parse(s));setScreen("app");}catch{setScreen("landing");}}
    else setScreen("landing");
  },[]);

  const handleLogin=(u)=>{setUser(u);setScreen("app");};
  const handleLogout=()=>{localStorage.removeItem("vm_session");setUser(null);setScreen("landing");};

  if(screen==="loading") return <div style={{minHeight:"100vh",background:"#07101f",display:"flex",alignItems:"center",justifyContent:"center"}}><style>{CSS}</style><Spinner/></div>;
  if(screen==="privacidade") return <PoliticaPrivacidade/>;
  if(screen==="coleta_publica") return <ColetaPublica linkId={linkId}/>;
  if(screen==="landing") return <Landing onComecar={()=>setScreen("cadastro")} onLogin={()=>setScreen("login")}/>;
  if(screen==="cadastro") return <FluxoCadastro onSuccess={handleLogin} onBack={()=>setScreen("landing")}/>;
  if(screen==="login") return <FormLogin onSuccess={handleLogin} onBack={()=>setScreen("landing")}/>;
  if(screen==="app"&&user) return <Painel user={user} onLogout={handleLogout}/>;
  return null;
}